import socket from './socket';

const getCardPointAdvancedData = (cardId, headers) =>
  socket.get(`/cards/${cardId}/card-point-advanced-data`, undefined, headers);

const createCardPointAdvancedData = (cardId, data, headers) =>
  socket.post(`/cards/${cardId}/card-point-advanced-data`, data, headers);

const updateCardPointAdvancedData = (id, data, headers) =>
  socket.patch(`/card-point-advanced-data/${id}`, data, headers);

const deleteCardPointAdvancedData = (id, headers) =>
  socket.delete(`/card-point-advanced-data/${id}`, undefined, headers);

export default {
  getCardPointAdvancedData,
  createCardPointAdvancedData,
  updateCardPointAdvancedData,
  deleteCardPointAdvancedData,
};

